import JobFormContainer from 'hb-react/shared/apps/JobForm/containers/JobFormContainer';
import { Provider } from 'hb-react/shared/apps/JobForm/containers/Provider';
import { useRenew } from 'hb-react/shared/apps/JobForm/hooks/useRenew';
import type { JobFormProps } from 'hb-react/shared/apps/JobForm/types';

const JobFormPo = (props: JobFormProps) => {
  const { job, mode } = props;

  useRenew({ isActive: false, jobId: job?.id });

  return (
    <Provider {...props}>
      <JobFormContainer mode={mode} />
    </Provider>
  );
};

export default JobFormPo;
